/**
 * Named corner radii.
 *
 * `shape.borderRadius` is 0 (sharp corners are the house default), so any
 * rounded corner is a deliberate exception. These tokens exist so those
 * exceptions are named and shared instead of repeated as magic numbers.
 */
export const CUSTOM_RADII = {
  /** Fully rounded ends: ask box, scrollbar thumb. */
  pill: "50px",
  /** Perfect circle: icon buttons, status dots. */
  circle: "50%",
  /** Cards and chat bubbles. */
  card: "10px",
  /** Small blocks: skeleton shimmer bars. */
  chip: "8px",
  /** Barely-rounded: avatars, inline labels, alerts. */
  subtle: "5px",
} as const;
